
import { types } from "../types/types";

const initialState = {
    citas: [],
    citasByMonth: {},
    active: null,
    citasHistoria: [],
    loading: false,
    error: null
}

export const citasReducer = ( state = initialState, action ) => {
    
    switch (action.type) {

        case types.citasActive:
            return {
                ...state,
                active: {
                    ...action.payload
                }
            }
        
        case types.citasUnactive:
            return {
                ...state,
                active: null
            }
        
        case types.citasAddNew:
            return {
                ...state,
                citas: [ action.payload, ...state.citas ]
            }
        
        case types.citasAddNewDouble:
            return {
                ...state,
                citas: [ action.payload, ...state.citas ]
            }

        case types.citasLoad:
            if (action.payload.fecha) {
                const monthKey = action.payload.fecha.substring(0, 7); // "2025-09"
                return {
                    ...state,
                    citas: [ ...action.payload.citas ],
                    citasByMonth: {
                        ...state.citasByMonth,
                        [monthKey]: action.payload.citas
                    }
                };
            }
            return {
                ...state,
                citas: [ ...action.payload ]
            }
        
        case types.citasLoadHistory:
            return {
                ...state,
                citasHistoria: action.payload || []
            }
        
        case types.citasComentariosUpdated:
            
            const citasConComentariosActualizados = state.citas.map(
                cita => cita._id === action.payload._id
                    ? { ...cita, comentarios: action.payload.comentarios }
                    : cita
            );
            
            const activeConComentariosActualizados = state.active && state.active._id === action.payload._id 
                ? { ...state.active, comentarios: action.payload.comentarios }
                : state.active;
            
            
            return {
                ...state,
                citas: citasConComentariosActualizados,
                active: activeConComentariosActualizados
            }

        case types.citasUpdated:
        case types.citaUpdated: {
            const idBuscado = action.payload._id;
            const updatedCitas = state.citas.map(
                cita => cita._id === idBuscado
                    ? action.payload
                    : cita
            );
            const updatedActive = state.active && state.active._id === idBuscado
                ? action.payload
                : state.active;
            const updatedCitasByMonth = { ...state.citasByMonth };
            Object.keys(updatedCitasByMonth).forEach(monthKey => {
                updatedCitasByMonth[monthKey] = updatedCitasByMonth[monthKey].map(
                    cita => cita._id === idBuscado
                        ? action.payload
                        : cita
                );
            });
            return {
                ...state,
                citas: updatedCitas,
                citasByMonth: updatedCitasByMonth,
                active: updatedActive
            };
        }

        case types.citasDelete: {
            const idEliminado = action.payload;
            const citasRestantes = state.citas.filter(cita => cita._id !== idEliminado);
            const citasByMonthActualizado = { ...state.citasByMonth };
            Object.keys(citasByMonthActualizado).forEach(monthKey => {
                const citasMes = citasByMonthActualizado[monthKey];
                if (Array.isArray(citasMes)) {
                    citasByMonthActualizado[monthKey] = citasMes.filter(
                        cita => cita._id !== idEliminado
                    );
                }
            });
            return {
                ...state,
                active: null,
                citas: citasRestantes,
                citasByMonth: citasByMonthActualizado
            };
        }
    
        case types.citasLogoutCleaning:
            return {
                ...state,
                citas: [],
                citasByMonth: {},
                active: null,
                citasHistoria: []
            }
    

        default:
            return state;
    }
}